<template>
    <div>
        <div>
            <v-menu
                bottom
                right
                offset-y
                :internal-activator="true"
                v-model="openMenu"
                content-class="no-contain overflow-visible"
                :close-on-content-click="false"
            >
                <template v-slot:activator="{ attrs, on }">
                  <v-btn style="padding: 0px 25px !important; margin-right: 10px;"
                         color="primary" dark v-on="on">
                    <span>Tìm kiếm</span>
                    <v-icon style="margin-left: 10px; margin-right: -20px;">mdi-chevron-down</v-icon>
                  </v-btn>
                </template>

                <v-card
                    width="400px"
                    outlined
                    class="ma-0"
                >
                  <v-row class="px-5 py-5 mt-3">
                    <v-col
                        class="py-0"
                        cols="12">
                      <v-autocomplete
                          v-model="filterForm.typeId"
                          :items="types"
                          item-text="name"
                          item-value="id"
                          label="Loại hình"
                          color="primary"
                          clearable
                      />
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-autocomplete
                          v-model="filterForm.schoolLevelId"
                          :items="listSchoolLevelByType"
                          item-text="name"
                          item-value="id"
                          label="Nhóm ngành"
                          :disabled="!filterForm.typeId"
                          color="primary"
                          clearable
                      />
                    </v-col>
                  </v-row>
                  <div class="text-center mb-4">
                    <v-btn
                        class="primary mx-0"
                        @click="search"
                    >
                      <v-icon>mdi-magnify</v-icon>Tìm kiếm
                    </v-btn>
                  </div>
                </v-card>
            </v-menu>
        </div>
    </div>
</template>

<script>
export default {
  name: 'FilterForm',
  props: {
    filterForm: {
      default: () => ({}),
    },
    types: {
      default: () => ([]),
    },
  },
  data () {
    return {
      openMenu: false,
    }
  },
  created() {

  },
  beforeDestroy() {

  },
  methods: {
    search () {
      this.openMenu = false
      Bus.$emit('hold-contact-setting-filter', this.filterForm)
    },
  },
  computed: {
    listSchoolLevelByType() {
      if(this.filterForm.typeId){
        const result = this.types.find(type => type.id === this.filterForm.typeId)
        return result ? result.schoolLevel : []
      } else return []
    }
  },
  watch:{
    'filterForm.typeId': function (newValue) {
      if(!newValue) {
        this.filterForm.schoolLevelId = undefined
      }
    }
  },
}
</script>

<style scoped>
.v-text-field {
  margin-top: 0 !important;
}
</style>
